import { Input } from '@ibsys/kit';
import { ArrowRightIcon } from 'lucide-react';
import type { FC, KeyboardEvent } from 'react';
import { useTranslation } from 'react-i18next';
import type { NumericFilterRange } from './numericFilterValue';

/** Пропсы отбора границами */
type Props = {
  range: NumericFilterRange;
  onChange: (range: NumericFilterRange) => void;
  /** Применяет отбор — по Enter в поле границы, как у встроенных фильтров грида */
  onApply: () => void;
  /** Границы не набираются: отбор задан не значением */
  disabled?: boolean;
};

/** Отбор границами «от–до»: обе включительно, заданная одна ограничивает выдачу с одной стороны */
export const NumericFilterRangeMode: FC<Props> = ({ range, onChange, onApply, disabled }) => {
  const { t } = useTranslation('common');

  const toBoundValue = (raw: string): number | undefined => (raw === '' ? undefined : Number(raw));

  const handleKeyUp = (event: KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'Enter') onApply();
  };

  return (
    <div className="flex items-center gap-2" onKeyUp={handleKeyUp}>
      <Input
        type="number"
        value={range.from ?? ''}
        onChange={(e) => onChange({ ...range, from: toBoundValue(e.target.value) })}
        isClearable
        onClear={() => onChange({ ...range, from: undefined })}
        placeholder={t('numericFilter.rangeFrom')}
        disabled={disabled}
        className="flex-1"
      />
      <ArrowRightIcon className="shrink-0 text-muted-foreground" size={18} strokeWidth={1.5} aria-hidden />
      <Input
        type="number"
        value={range.to ?? ''}
        onChange={(e) => onChange({ ...range, to: toBoundValue(e.target.value) })}
        isClearable
        onClear={() => onChange({ ...range, to: undefined })}
        placeholder={t('numericFilter.rangeTo')}
        disabled={disabled}
        className="flex-1"
      />
    </div>
  );
};
